export default "__VITE_ASSET__3b9a7f3a__"